import {Divider, SimpleGrid, Transition} from "@mantine/core";
import QRCodeKind from "../../../../api/qr-code/QRCodeKind";
import Item from "./Item";
import {useContext, useEffect, useState} from "react";
import CreateQRCodeContext from "../CreateQRCodeContext";
import {showNotification} from "@mantine/notifications";

type ChooseKindProps = {
    /**
     * Will return empty div, if context contains selected kind.
     * Optional of course.
     * @author Kacper Faber
     * @since 0.1.8
     */
    hideWhenPicked?: boolean;
}

/**
 * List of allowed kinds.
 * If selected kind is not in this list, we'll throw an error.
 * @author Kacper Faber
 * @since 0.1.9
 */
const allowedKinds: QRCodeKind[] = ['website', 'vcard', 'image', 'pdf'];

/**
 * Component to render possible QRCode kinds [to generate].
 * Must be in CreateQRCodeContext.
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function ChooseKind(props: ChooseKindProps) {
    /**
     * Create QR code context.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(CreateQRCodeContext);

    const [isTransitionMounted, setTransitionMounted] = useState(false);

    const renderItem = (kind: QRCodeKind, label: string, desc: string) => {
        return (
            <Item
                kind={kind}
                label={label}
                description={desc}
            />
        );
    }

    const onMount = () => {
        setTransitionMounted(true);
        return () => setTransitionMounted(false);
    };

    const onKindChange = () => {
        if (ctx.kind && !allowedKinds.includes(ctx.kind)) {
            showNotification(
                {
                    title: 'Niestety, ten kod nie działa',
                    message: 'Ten kod nie działa i nie może być wybrany.'
                }
            );
            ctx.setKind(null);
        }
    }

    useEffect(onMount, []);

    useEffect(onKindChange, [ctx.kind])

    if (ctx.kind !== null && props.hideWhenPicked === true) {
        return (
            <div></div>
        );
    }


    return (
        <Transition mounted={isTransitionMounted} transition="slide-up" duration={500}>
            {styles =>
                <div style={styles}>
                    <Divider
                        label="Dynamiczne"
                    />

                    <SimpleGrid mt="xl" cols={{xs: 1, sm: 1, md: 2}}>
                        {renderItem('vcard', 'VCard Plus', 'Dynamiczna wizytówka')}
                        {renderItem('website', 'Strona internetowa', 'Link do strony internetowej')}
                        {renderItem('image', 'Pojedyncze zdjęcie', 'Pobierz pojedyncze zdjęci')}
                        {renderItem('pdf', 'Dokument PDF', 'Pobierz dokument PDF')}
                    </SimpleGrid>
                </div>
            }
        </Transition>
    );
}

export default ChooseKind;

// TODO: ChooseKind.tsx
//  Add some beauty.